import moment from 'moment'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { cn } from '@repo/utils'

import { ChildrenSchema } from 'utils'

import SimpleButton from '../../SimpleButton'

import styles from './index.css'

class Event extends PureComponent {
  render() {
    const { categoryId, className, datetime, icon, title, ...props } = this.props
    const date = moment(datetime)

    return (
      <SimpleButton
        {...props}
        ariaLabel={`${date.format('hh:mm a')}: ${title}`}
        className={cn(className, styles.wrapper, styles[`cat0${categoryId}`])}
      >
        {!!icon && <span className={styles.icon}>{icon}</span>}
        <span className={styles.date}>{date.format('HH:mm')}</span>
        <span>{title}</span>
      </SimpleButton>
    )
  }
}

Event.propTypes = {
  datetime: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  title: ChildrenSchema.isRequired,

  categoryId: PropTypes.number,
  className: PropTypes.string,
  icon: ChildrenSchema,
}

Event.defaultProps = {
  categoryId: 0,
  className: '',
  icon: null,
}

export default Event
